<template lang="pug">
.bg-page
  .container
    section
      .title-decoration
        .dot
        .dot
        .dot
        .dot
      h1 {{ $route.meta.title }}
      p.text-center(style="margin-bottom:32px;")
        | WirForce 期間，4Gamers 安排了各種比賽與活動，不管你是否到場參加，都別忘了密切關注以下節目表，若你真的無法到場同樂，也別忘了鎖定 4Gamers 的 Twitch 頻道
        br
        br
        span 《主舞台》
        a.link-red(href="https://www.twitch.tv/wirforce", target="_blank") https://www.twitch.tv/wirforce
        br
        span 《BYOC 舞台》
        a.link-red(href="https://www.twitch.tv/wirforce_byoc", target="_blank") https://www.twitch.tv/wirforce_byoc
        br
        br
        | 我們也會宣導在 byoc 的實況主加入以下 team，讓所有在 
        a.link-red(href="https://www.twitch.tv/team/wirforce", target="_blank") WirForce 的直播集
        |  中宣傳！
    programList
    .mb-40
</template>

<script>
import { mapGetters } from 'vuex'
import programList from './programList'
// import _ from 'lodash'

export default {
  name: 'highlights',
  beforeRouteEnter (to, from, next) {
    next(vm => {
    })
  },
  beforeRouteLeave (to, from, next) {
    next(vm => {
    })
  },
  components: {
    programList
  },
  props: {
    fullScreenCount: {
      type: Object
    },
    isMobile: {
      type: Boolean
    },
    mobileMenuSwitch: {
      type: [Boolean, Function]
    },
    isPortrait: {
      type: Boolean
    }
  },
  data () {
    return {
      nowTab: 0,
      days: ['11/23 (四)', '11/24 (五)', '11/25 (六)', '11/26 (日)']
    }
  },
  computed: {
    ...mapGetters([
    ])
  },
  methods: {
  },
  mounted () {
    // Place images after loaded
    this.$Lazyload.$on('loaded', () => {
      console.log('Loaded')
    })
  },
  watch: {
  },
  beforeDestroy () {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="sass" scoped>
@import '~stylesheets/variables'
@import '~stylesheets/components'
@import '~stylesheets/mixin'
</style>



// WEBPACK FOOTER //
// highlights.vue?a56aefe0